import React, { FC, Fragment } from 'react';
import CategoryTreeItem from 'modules/shared/components/category-tree/components/components';
import CategoryTreeList from 'modules/shared/components/category-tree/components';

export interface CategoryTreeInterface {
    id: string;
    url: string;
    name: string;
    amount?: number;
    active?: boolean;
}

export interface CategoriesTreeInterface {
    parent?: CategoryTreeInterface;
    list: CategoryTreeInterface[];
}

interface CategoryTreeProps {
    categories: CategoriesTreeInterface[];
    limitItems?: number;
    isShowAll?: boolean;
    producerTemplate?: boolean;
}

const CategoryTree: FC<CategoryTreeProps> = ({ categories, limitItems, isShowAll = false, producerTemplate = false }) => {
    return (
        <ul className="category-tree">
            {categories.map(category => (
                <Fragment key={category.parent?.id || category.list[0].id}>
                    {category.parent && !producerTemplate && (
                        <CategoryTreeItem
                            name={category.parent.name}
                            url={category.parent.url}
                            isActive={category.parent.active}
                            isParent={true}
                            amount={category.parent.amount}
                        />
                    )}
                    <li>
                        <CategoryTreeList
                            list={category.list}
                            limitItems={limitItems}
                            showAllLink={isShowAll ? (category.parent?.url || category.list[0].url) : void 0}
                        />
                    </li>
                </Fragment>
            ))}
        </ul>
    );
};

export default CategoryTree;
